import configuration from "../components/config/Config";
import s3 from "../components/config/DigitalOcean";
import { REWRITE_URLS } from "../components/config/Api";

export const handleUploadHtmlFile = async (file, FilePath, setCopyUploadLoading, setCopyUpload, setFormData, formData ) => {
    const params = {
        Body: file,
        Bucket: `${configuration.bucketName}`,
        Key: FilePath,
        ACL: "public-read",
        ContentType: "text/html",
    };
    s3.putObject(params)
        .on("build", (request) => {
            request.httpRequest.headers.Host = `${REWRITE_URLS === "1"
                    ? configuration.digitalOceanSpacesRewrite
                    : configuration.digitalOceanSpaces
                }`;
            request.httpRequest.headers["Content-Length"] = file.size;
            request.httpRequest.headers["Content-Type"] = file.type;
            request.httpRequest.headers["x-amz-acl"] = "public-read";
            request.httpRequest.headers["Access-Control-Allow-Origin"] = "*";
            setCopyUploadLoading(false);
            setCopyUpload(true);
        })
        .send((err) => {
            if (err) {
                console.log("Img error", err);
                // toast.error(err.response.data.message);
                setFormData({
                    ...formData,
                    html_data_file_path: "",
                });
                setCopyUploadLoading(false);
                throw Error({ message: err.response.data.message })
            }
        });
}